import React from 'react';
import { useTranslation } from 'react-i18next';
import LayoutNavbar from '@root/components/LayoutNavbar';
import SelectCountry from '@root/containers/Login/SelectCountry';

const SelectCountryPage = () => {
  const { t } = useTranslation();

  return (
    <LayoutNavbar
      navbarProps={{
        title: t('country'),
      }}
      isHomeIcon={false}
    >
      <SelectCountry />
    </LayoutNavbar>
  );
};

export default SelectCountryPage;
